import { FC, useState } from "react"
import { useTranslation } from "react-i18next"
import { useGET_kpiStudentSubjectQuery } from "redux/api/kpiEvaluationsApi"
import { useGET_studentByProfileIdQuery } from "redux/api/studentsApi"
import { useNavigate } from 'react-router-dom'
import { Avatar, Button } from "@mui/material"
import { PRIMARY_TRANSPARENT_GREEN } from "utils/customizedTheme"
import { TrendingDown, TrendingUp, WarningAmber } from "@mui/icons-material"
import KpiStudentDiagnostic from "./KpiStudentDiagnostic"
import RtiInterventionForm from "components/organisms/forms/RtiInterventionForm"
import BenchmarkStudentIntervention from "../benchmarks/BenchmarkStudentIntervention"

//import KpiStudentDiagnostic from "./KpiStudentDiagnostic"
//import KpiStudentIntervention from "./KpiStudentIntervention"
//import RtiInterventionForm from "components/organisms/forms/RtiInterventionForm"


interface IProps {
  subject: any
  student: string
}

const KpiStudent: FC<IProps> = ({subject, student}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const [tab, setTab] = useState('diagnostic')
  const [showInterventionForm, setShowInterventionForm] = useState(false)

  const {data: studentData} = useGET_studentByProfileIdQuery(student)
  const { data: kpiData } = useGET_kpiStudentSubjectQuery({student: student, subject: subject.id})
  
  const deviation = studentData ? studentData.baseline_score - 50 : 0

  if(!studentData || !kpiData) return <></>

  return (
    <>
        <div style={{ display: 'flex', width: '100%' }}>
            <div style={{ borderRight: '1px solid #78b232', width: '220px' }}>
                <div style={{ background: '#c1e398', padding: '0px' }}>

                    <div style={{ width: '100', textAlign: 'center', cursor: 'pointer'  }} 
                        onClick={() => navigate(`/students/edit/${studentData.id}`)}>

                        <div style={{ paddingTop: '20px', paddingBottom: '20px'}}>
                            <Avatar
                                    sx={{
                                        bgcolor: PRIMARY_TRANSPARENT_GREEN,
                                        width: 100,
                                        height: 100,
                                        display: 'flex',
                                        alignItems: 'center',
                                        textAlign: 'center',
                                        margin: 'auto'
                                    }}
                                    variant='circular'
                                    src={studentData.avatar}
                                    >
                            </Avatar>
                        </div>
                        <div style={{ background: '#78b332', padding: '5px', color: '#fff', fontSize: '20px', textAlign: 'center' }}>
                            { studentData.first_name } {studentData.last_name}    
                        </div>
                    </div>

                </div>
                <div style={{ padding: '10px', background: '#fcf6e5' }}>
                    <div className="details">
                        <div className="details-row"><div>{t('common.academic-id')}</div><div>{studentData.academic_id}</div></div>
                        <div className="details-row"><div>{t('common.grade-level')}</div><div>{studentData.grade_level}</div></div>
                        {studentData.group && <div className="details-row"><div>{t('common.group')}</div><div>{studentData.group}</div></div>}
                    </div>    

                    <div className="details-box">
                        <div className="details">
                            <div className="details-title">{t('common.rti-interventions')}</div>
                            <div className="details-row"><div>{t('common.tier')}</div><div>{studentData.tier}</div></div>
                        </div>
                    </div>

                    <div className="details-box">
                        <div className="details">
                            <div className="details-title">{t('common.academic-performance')}</div>
                            <div className="details-row"><div>{t('common.deviation')}</div>
                                <div>
                                    <div style={{ display: 'inline-flex', gap: 5 }}>
                                        <span>{deviation}%</span>
                                        {deviation > 0 
                                            ? <TrendingUp style={{ color : '#78b332' }} /> 
                                            : <TrendingDown style={{ color : '#f5635e' }} /> }
                                    </div>
                                </div>
                            </div>
                            <div className="details-row">
                                <div>{t('common.risk')}</div>
                                <div>
                                    <div style={{ display: 'inline-flex', gap: 5 }}>
                                        <span>{studentData.risk}%</span>
                                        <WarningAmber style={{ color: '#faaa20' }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div style={{ padding: '20px', flex: 1 }}>


                <div className="info-box">
                    <div className="info-box-title">

                        <div style={{ display: 'flex', alignItems: 'center', width: '100%', gap: '20px'}}>
                            <div style={{ textAlign: 'left', flex: 1, fontSize: '30px', fontWeight: 700 }}>
                                {subject.title}
                            </div>
                            
                            <div>
                                <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                                    <Button
                                        variant={tab == 'diagnostic' ? 'contained' : 'outlined'}
                                        color={tab == 'diagnostic' ? 'primary' : 'black'}
                                        onClick={() => { setTab('diagnostic') }}
                                        >
                                        {`${t('common.diagnostic')}`}
                                    </Button>

                                    {kpiData.intervention && 
                                    <Button sx={{ marginLeft: '10px' }}
                                        variant={tab == 'intervention' ? 'contained' : 'outlined'}
                                        color={tab == 'intervention' ? 'primary' : 'black'}
                                        onClick={() => { setTab('intervention') }}
                                        >
                                        {`${t('common.intervention')}`}
                                    </Button>}
                                </div>
                                    
                            </div>
                        </div>
                    </div>
                </div>

                
                {tab == 'diagnostic' && <KpiStudentDiagnostic 
                    student={student}
                    subject={subject}
                    studentData={studentData}
                    kpiData={kpiData}
                />}

               
                {tab =='intervention' && kpiData.intervention && !showInterventionForm && <BenchmarkStudentIntervention
                    student={student}
                    intervention={kpiData.intervention}
                    onEditClick={() => {setShowInterventionForm(true)}}
                />}

                {tab =='intervention' && (!kpiData.intervention || showInterventionForm) &&  
                    <RtiInterventionForm 
                        action={'edit'} 
                        id={student} 
                        viewOnly={false} 
                        onSuccess={() => {setShowInterventionForm(false)}}
                    />}
                
            </div>
        </div>
    </>
  )
}

export default KpiStudent
